module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("95NFK"))).then(() => parcelRequire('hEqeo'));